import React, { useContext } from "react";
import styled from "styled-components";
import { AppContext } from "./AppProvider";
import ViewBox from "./ViewBox";

const SVGStyles = styled.div`
  width: 50%;
`;

function SVG({ path }) {
  const ctx = useContext(AppContext);
  return (
    <SVGStyles>
      <svg
        // ref={ref}
        viewBox={`${ctx.minX} ${ctx.minY} ${ctx.width} ${ctx.height}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={path} />
      </svg>
    </SVGStyles>
  );
}

export default SVG;
